import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=b87e1788&scoped=true"
import script from "./CustomHeader.vue?vue&type=script&lang=js"
export * from "./CustomHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomHeader.vue?vue&type=style&index=0&id=b87e1788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87e1788",
  null
  
)

export default component.exports